import { useState, useEffect, React } from 'react';
import { toast } from 'react-toastify';
import { Modal, Form, Button } from 'react-bootstrap';
import axios from 'axios';
import { URL_AWS } from '../../constans/servidor';

const ForgotPassword = ({ open, onOpen }) => {
  const [nit, setNit] = useState('');
  const [showLoading, setShowLoading] = useState(false);

  const handleSubmit = async (e) => {
    setShowLoading(true);
    e.preventDefault();
    if (!nit || nit.trim() === '') {
      toast.error('El NIT es requerido');
      setShowLoading(false);
      return;
    }
    try {
      const response = await axios.post(`${URL_AWS}/Suppliers/forgotPasswordSupplier`, { nit });
      console.log(response);
      if (response.data.status === true) {
        toast.success(response.data.message || 'Se ha enviado un correo para recuperar la contraseña');
        onOpen(false);
        setShowLoading(false);
        return;
      } else {
        toast.error(response.data.message || 'Error al recuperar la contraseña');
        setShowLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message || 'Error al recuperar la contraseña');
      setShowLoading(false);
      return;
    }
  }

  return (
    <Modal size="md" show={open} onHide={() => onOpen(false)} className="be-modal">
      <Modal.Header closeButton>
        <Modal.Title className='text-center'>Recuperar contraseña</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">
          Ingresa el NIT con el digito de verificación y guión de la empresa o proveedor para ayudarte con la
          recuperación de tu cuenta
        </p>
        <Form className="conten-login">
          <Form.Group>
            <Form.Label>NIT</Form.Label>
            <Form.Control type="text" placeholder="Ingresa tu NIT" value={nit} onChange={(e) => setNit(e.target.value)} />
          </Form.Group>
          <div className="text-center">
            {showLoading ? <div className="container-sniper text-center"></div> : (<Button className="btn-borde-verde" size="sm" type="submit" onClick={handleSubmit}>Recuperar contraseña</Button>)}
          </div>
          <div className="text-center">
            <Button
              onClick={() => onOpen(false)}
              variant="link"
              className="btn-enlace-gris"
            >
              Cancelar
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default ForgotPassword;